module.exports = "<div class=\"boolean-component\" [formGroup]=\"formGroupObj\">\n  <button\n    class=\"roundButton\"\n    [ngClass]=\"{ activeBtn: isActive() }\"\n    (click)=\"clickButton($event)\"\n  >\n    {{ label }}\n  </button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/components/boolean/boolean.component.html
// module id = ./src/app/admin/components/boolean/boolean.component.html
// module chunks = main